// Keeps anchor targets from being hidden under the sticky header.
// The header height (incl. WP admin bar offset) is exposed as --header-offset,
// which is used by `scroll-padding-top` on <html> (see base/_base.scss).

const updateHeaderOffset = (header) => {
  const top = parseFloat(getComputedStyle(header).top) || 0
  document.documentElement.style.setProperty('--header-offset', `${header.offsetHeight + top}px`)
}

const scrollToHash = () => {
  if (!window.location.hash) return

  let target = null

  try {
    target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)))
  } catch (e) {
    return
  }

  if (target) {
    target.scrollIntoView({ behavior: 'instant', block: 'start' })
  }
}

export default function initSmoothScrolling() {
  const header = document.getElementById('header')

  if (!header) return

  updateHeaderOffset(header)

  if ('ResizeObserver' in window) {
    new ResizeObserver(() => updateHeaderOffset(header)).observe(header)
  }

  window.addEventListener('resize', () => updateHeaderOffset(header))

  // The browser jumps to the hash before the offset is known and before
  // images/fonts shift the layout, so re-align once everything is loaded.
  scrollToHash()
  window.addEventListener('load', scrollToHash, { once: true })
}
